import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentState, UIComponentHandler } from '../../../../toolkit/uicomponent';
import * as React from 'react';
import { TransactionHistoryRowComponentProps } from './transactionhistoryrowcomponent';
import { BaseContext } from '../../../../../utils/basecontext';
import { EnglishTransactionHistoryRowCSSStyle, EnglishTransactionHistoryRowCSSStyleImpl } from './transactionhistoryrowcss';
import 'moment-timezone';
import { TextTransform } from '../../../../toolkit/texttransform/texttransform';
import './history-style.css';
import { EnglishTransactionHistoryListCSSStyle, EnglishTransactionHistoryListCSSStyleImpl } from './listcss/transactionhistorylistcss';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';

export class TransactionHistoryRowViewImpl extends UIComponentViewImpl<UIDataModel>
{
   private historyCssStyle: EnglishTransactionHistoryRowCSSStyle;
   private litCSSStyle:EnglishTransactionHistoryListCSSStyle;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);


        this.litCSSStyle = new EnglishTransactionHistoryListCSSStyleImpl(context);
        this.historyCssStyle =  new EnglishTransactionHistoryRowCSSStyleImpl(context);
    }

    bindHandlers():void
    {
        // this.getDateConvertor = this.getDateConvertor.bind(this);
    }
    
    draw(props: TransactionHistoryRowComponentProps, state: UIComponentState, cssStyle: EnglishTransactionHistoryRowCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
         <tr id="history-wrapper" style={this.historyCssStyle.getWrapperCSSStyle()}> 

            <div id="history-content" style={{width:'100%',height:"100%",padding:"10px"}}>
                {this.getTableView(props)}
            </div>
            <div id="history-col-content" style={{width:'100%', height:'100%',flexFlow: "row wrap",flexDirection:'row',}}>
              
                {this.getTableColumnView(props)}
            </div>    
         </tr>  
         
        );
    }
  

    private getTableColumnView(props:TransactionHistoryRowComponentProps):JSX.Element
    {
        return(
            <div style={this.litCSSStyle.getWrapperCSSStyle()}>
                 <td id="col1" style={this.litCSSStyle.getTitleDivCSSStyle()}>
                        <label style={this.litCSSStyle.getTitleLabelCSSStyle()}>
                                {props.transactionHistoryDto.getTitle()}
                        </label>
                </td>
                <td id="col2" style={this.litCSSStyle.getTimestampDivCSSStyle()}>
                        <label style={this.litCSSStyle.getTimestampLabelCSSStyle()}>
                        {props.transactionHistoryDto.getTimeStamp()}
                        </label>
                </td>
                <td id="col3" style={this.litCSSStyle.getPriceDivCSSStyle()}>
                        <label style={this.litCSSStyle.getPriceLabelCSSStyle()}>
                                {props.transactionHistoryDto.getPrice()}
                        </label>
                </td>
                <td id="col4" style={this.litCSSStyle.getDurationDivCSSStyle()}>
                        <label style={this.litCSSStyle.getPriceLabelCSSStyle()}>
                                {props.transactionHistoryDto.getDuration()}
                        </label>
                </td>
                <td id="col5" style={this.litCSSStyle.getTransactionTypeDivCSSStyle()}>
                        <label style={this.litCSSStyle.getTransactionTypeLabelCSSStyle(props.transactionHistoryDto.getTransactionType())}>
                                {props.transactionHistoryDto.getTransactionType()}
                        </label>
                </td>
                <td id="col6"  style={this.litCSSStyle.getChannelTypeDivCSSStyle()}>
                        <label style={this.litCSSStyle.getChannelTypeLabelCSSStyle()}>
                                {props.transactionHistoryDto.getChannel()}
                        </label>
                </td>
              
            </div>
        );
    }

    private getTableView(props:TransactionHistoryRowComponentProps):JSX.Element
    {
        return(
        <td style={this.historyCssStyle.getInnerDiv1CSSStyle()}>
            <div style={this.historyCssStyle.getInnerDiv2CSSStyle()}>
                   
                   <div style={this.historyCssStyle.getHeader1DivCSSStyle()}>
                       <label style={this.historyCssStyle.getLabel1CSSStyle()}>
                           {TextTransform.convertToCaptialize(props.transactionHistoryDto.getTitle())}
                       </label>
                   </div>    
                   <div style={this.historyCssStyle.getHeader2DivCSSStyle()}>
                       <label style={this.historyCssStyle.getLabel2CSSStyle()}>
                           {props.transactionHistoryDto.getPrice()}
                       </label> 
                   </div>    
       
               </div>
               <div style={this.historyCssStyle.getBardDivCSSStyle()}/>
                 <div  style={this.historyCssStyle.getInnerDiv2CSSStyle()}>
                     <div  style={this.historyCssStyle.getHeader1DivCSSStyle()}>
                             <label style={this.historyCssStyle.getContentCSSStyle()}>
                             {props.context.getResources().getString(Strings.date_time)}
                             </label>
                     </div>
                     <div style={this.historyCssStyle.getHeader2DivCSSStyle()}>
         
                             <label style={this.historyCssStyle.getContentCSSStyle()}>
                             {props.context.getResources().getString(Strings.channel_type)}
                             </label>
                     </div>        
                 </div>
                 <div style={this.historyCssStyle.getInnerDiv2CSSStyle()}>
                            <label style={this.historyCssStyle.getDateLabelCSSStyle()}>
                            {props.transactionHistoryDto.getTimeStamp()}
                            </label>
                            <label style={this.historyCssStyle.getChannelTypeCSSStyle()}>
                            {props.transactionHistoryDto.getChannel()}
                            </label>
                </div>
           <div style={{width:"100%",height:"30px",display:"flex"}}>
              <div style={{width:"40%",height:"100%"}}>
                <div style={this.historyCssStyle.getStatusDivCSSStyle(props.transactionHistoryDto.getTransactionType())}>
                    <div style={this.historyCssStyle.getRoundIconCSSStyle(props.transactionHistoryDto.getTransactionType())}/>
                        <label style={this.historyCssStyle.getStatusLabelCSSStyle()}>
                            {props.transactionHistoryDto.getTransactionType()}
                        </label>
                
                    </div>

                    </div>    
                    <div style={{width:"60%",display:"inline-block",textAlign:"right",height:"30px"}}>
                        <div style={this.historyCssStyle.getValidityHeaderCSSStyle()}>
                                {props.context.getResources().getString(Strings.validity)}
                        </div>
                            <div style={this.historyCssStyle.getValidityCSSStyle()}>
                            {props.transactionHistoryDto.getDuration()}
                            </div>
                    </div>

            </div>    
          
         </td>   


        );

       
    }
    // private getDateConvertor(timestamp:string):string
    // {
    //     console.log("Date Convertion ------", moment().format("DD/MM/yyyy  HH:mm"));
    //     return  moment(timestamp).format("DD/MM/yyyy,  HH:mm");
    // }

    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/transactionhistory/viewmodel/transactionhistoryrowview.tsx